import { take, filter, map, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

/**
 * Manages the global state and API interactions for a user's
 * Accounts, via the new ProviderAccounts API.
 *
 */
export class EventsService {

  /** @type {import('../pusher/pusher.service').PusherService} */
  _PusherService;
  /** @type {import('../../core-services/user.service').UserService} */
  _UserService;

  /** @type {Subject<any>} */
  events$;

  /**
   * @param {string} userId
   */
  start(userId) {
    this._PusherService.connect(userId);

    console.log("[EventsService] start()");
  }

  stop() {
    // this._PusherService.disconnect();

    console.log("[EventsService] stop()");
  }

  constructor (
    PusherService,
    $q,
  ) {
    this._PusherService = PusherService;
    this._$q = $q;
    this.events$ = new Subject();

    this._PusherService.events$
      .subscribe(event => {
        console.log("PusherService event :: ", event);
        this.events$.next(event);
      });
  }
}

export default [
  'PusherService',
  '$q',
  EventsService,
];


